// CreatePlacement utilities – extracted from CreatePlacementOrPackageService
import { PlacementDetailsTableService } from '../';
import { Utils } from "../../../shared";

export const validateFormData = (formData, taxonomyFields) => {
  const errors = {};
  let isValid = true;
  if (formData['Placement Schema'] && taxonomyFields) {
    const schemaFields = formData['Placement Schema'].split('|');
    schemaFields.forEach(fieldName => {
      const fieldConfig = taxonomyFields.find(field => field.name === fieldName);
      const value = formData[fieldName];
      if (fieldConfig && fieldConfig.field_type !== 1) {
        const validation = PlacementDetailsTableService.validateFreeText(value, fieldConfig);
        if (!validation.isValid) {
          errors[fieldName] = validation.message;
          isValid = false;
        }
      }
    });
  }
  return { isValid, errors };
};

export const assignParameterValueToChildPlacementUpdatePayload = (payload, parentPayload, name) => {
  payload["parameterCode"] = parentPayload["parameterCode"];
  payload["parameterCodeTaxonomyDisplay"] = parentPayload["parameterCodeTaxonomyDisplay"];
  payload["parameterCodeTaxonomySchema"] = parentPayload["parameterCodeTaxonomySchema"];
  if (payload.name === 'Buy Type') {
    payload["placementType"] = parentPayload['placementType'];
  } else if (payload.name === 'Site') {
    payload["provider"] = parentPayload[name];
    payload[name] = parentPayload[name];
  } else if (payload.name === 'Ad Verification') {
    payload['ad_verification'] = parentPayload['ad_verification'];
  } else if (payload.name === 'Ad Server') {
    payload['ad_server'] = parentPayload['ad_server'];
  } else if (payload.name === 'Dimension/Positions') {
    payload['dimensionsPosition'] = parentPayload['dimensionsPosition'];
  } else {
    payload[name] = parentPayload[name];
  }
  return payload;
};

export const getPackageType = (programmaticType) => {
  switch (programmaticType) {
    case 'Placement':
      return "ProgrammaticPlacement";
    case 'Line Item':
    case 'Social Line Item':
      return "DSP";
    case 'Creative Placement':
      return "Child";
    default:
      break;
  }
};

export const getProgrammaticType = (programmaticType, socialProgrammaticFlag) => {
  if (programmaticType === 'ProgrammaticPlacement') {
    return 'Placement';
  } else if (socialProgrammaticFlag && programmaticType === 'DSP') {
    return "Social Line Item";
  } else if (programmaticType === 'DSP') {
    return "Line Item";
  } else if (programmaticType === 'Child') {
    return "Creative Placement";
  }
};

export const createFormDataForPlanItPackage = (planitData, childData) => {
  return {
    'isOverride': true,
    'packageType': childData.packageType === 'Child' ? 'Package' : 'Standalone',
    'Placement Name': planitData.placement_taxonomy,
    'Placement Display Name': planitData.placement_taxonomy_display,
    'Override Placement Name': planitData.placement_taxonomy,
    'Override Placement Display Name': planitData.placement_taxonomy_display,
    'Placement Schema': planitData.taxonomy_schema,
    'Parameter Code Buy Type': childData.placement_type,
    'Parameter Code': childData.parameterCode,
    'Parameter Code Display Name': childData.parameterCodeTaxonomyDisplay,
    'Parameter Code Schema': childData.parameterCodeTaxonomySchema,
    'TierId': planitData.tier_id,
    'Flight Start': Utils.formatDateObject(planitData.flight_start.split(" ")[0]),
    'Flight End': Utils.formatDateObject(planitData.flight_end.split(" ")[0]),
    'Unit Amount': planitData.unit_amount,
    'Rate': planitData.rate,
    'Planned Cost': planitData.planned_cost,
    'Parameter Code Unit Type': planitData.unit_type,
    'Parameter Code Site': childData.site
  };
};

export const convertObjectKeys = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach(key => {
    const newKey = key.replace(/_/g, '').toLowerCase();
    newObj[newKey] = obj[key];
  });
  return newObj;
};

export const cleanAndConvertString = (str) => {
  return str.replace(/[_\/\s]/g, '').toLowerCase();
};

export function updatePdmsDataInPlacementTaxonomyFields(schemaArr, DefaultData, placementData, fields) {
  if (placementData?.data_source === 'planit') {
    const updatePlacementData = convertObjectKeys(placementData);
    schemaArr.forEach((field) => {
      let updatedFieldValue = updatePlacementData[cleanAndConvertString(field)];
      updatedFieldValue = updatedFieldValue?.toLowerCase();
      if (updatedFieldValue) {
        fields.forEach((tfield) => {
          if (tfield.name === field) {
            if (tfield?.field_type === 1) {
              tfield.fielditems.forEach((fieldOption) => {
                if (cleanAndConvertString(fieldOption.name) === updatedFieldValue) {
                  DefaultData[field] = fieldOption.code;
                }
              });
            } else {
              DefaultData[field] = updatePlacementData[cleanAndConvertString(field)];
            }
          }
        });
      }
    });
  }
}

export function updatePdmsDataInParameterCodeTaxonomyFields(DefaultData, placementData, fields) {
  if (placementData?.data_source === 'planit') {
    const updatePlacementData = convertObjectKeys(placementData);
    const parameterSchema = fields.map(item => item.name);
    parameterSchema.forEach((field) => {
      let updatedFieldValue = updatePlacementData[cleanAndConvertString(field)];
      updatedFieldValue = updatedFieldValue?.toLowerCase();
      if (updatedFieldValue) {
        fields.forEach((tfield) => {
          if (tfield.name === field) {
            if (tfield?.field_type === 1) {
              tfield.fielditems.forEach((fieldOption) => {
                if (cleanAndConvertString(fieldOption.name) === updatedFieldValue) {
                  DefaultData['Parameter Code ' + field] = fieldOption.code;
                }
              });
            } else {
              DefaultData['Parameter Code ' + field] = updatePlacementData[cleanAndConvertString(field)];
            }
          }
        });
      }
    });
  }
}
